import React, { useRef, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Upload, X, Image as ImageIcon, Loader2 } from "lucide-react";

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}

export default function ImageUpload({ value, onChange, testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => inputRef.current?.click();

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Please choose an image file"); return; }
    setBusy(true);
    try {
      const url = await uploadImage(file);
      onChange(url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Upload failed");
    } finally { setBusy(false); if (inputRef.current) inputRef.current.value = ""; }
  };

  return (
    <div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`${testid}-input`} />
      {value ? (
        <div className="relative inline-block group">
          <img src={value} alt="preview" className="h-24 w-auto max-w-[220px] rounded-lg border border-line object-cover bg-ink" data-testid={`${testid}-preview`} />
          <div className="absolute inset-0 flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity bg-black/50 rounded-lg">
            <button type="button" onClick={pick} className="text-xs px-2 py-1 rounded-full bg-ember text-black font-medium" data-testid={`${testid}-replace`}>Replace</button>
            <button type="button" onClick={() => onChange("")} className="text-xs px-2 py-1 rounded-full bg-white/90 text-black font-medium" data-testid={`${testid}-remove`}><X className="w-3 h-3" /></button>
          </div>
        </div>
      ) : (
        <button type="button" onClick={pick} disabled={busy}
          className="flex items-center gap-2 h-24 w-full max-w-[220px] rounded-lg border border-dashed border-line bg-ink text-content-muted hover:text-ember hover:border-ember/50 transition-colors justify-center text-sm"
          data-testid={`${testid}-btn`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {busy ? "Uploading…" : "Upload image"}
        </button>
      )}
      <div className="flex items-center gap-1 mt-1 text-[11px] text-content-muted"><ImageIcon className="w-3 h-3" /> PNG/JPG/WebP, up to 10 MB</div>
    </div>
  );
}
